import type { ApiTabValueType } from './types';

export const DEFAULT_API_TAB: ApiTabValueType = 'webhooks';

export const MAX_API_KEYS_PER_ORG = 20;

export const API_PAGE_SUBTITLE =
  'Manage programmatic access to your Crossbeam data with webhooks, integrations, keys, and filters.';

/** Placeholder until the customer-facing developer docs URL is confirmed. */
export const API_DOCS_URL = 'https://developers.crossbeam.com';
